<template>
  <div>
    <!-- filter and reset form -->
    <form class="mb-3">
      <div class="row">
        <div class="col-xl-5 col-sm-6">
          <div class="form-group mt-3 mb-0">
            <label>From :</label>
            <date-picker v-model="datepickervalueFrom" :first-day-of-week="1"
              :disabled-date="(date) => date >= new Date()" lang="en"></date-picker>
          </div>
        </div>

        <div class="col-xl-5 col-sm-6">
          <div class="form-group mt-3 mb-0">
            <label>To :</label>
            <date-picker v-model="datepickervalueTo" :first-day-of-week="1" :disabled-date="(date) =>
                date < new Date(datepickervalueFrom) || date >= new Date()
              " lang="en"></date-picker>
          </div>
        </div>
        <div class="col-xl-2 col-sm-6 align-self-end">
          <div class="mt-3">
            <button type="button" class="btn btn-primary w-md" @click="filterDataFromDates">
              Apply
            </button>
          </div>
        </div>
        <div class="col-10 row">
          <div class="col-6 mt-3" v-for="types in reportTypes" :key="types.id">
            <input class="form-check-input" type="checkbox" :value="types.id" :id="types.id" v-model="checkedTypes"
              style="margin-right: 7px" />
            <label class="form-check-label" :for="types.id">{{ types.type_name }}
            </label>
          </div>
        </div>
      </div>
    </form>
    <hr />

    <div class="download-details" v-if="this.allReports.length > 0">
      <h5>Download Reports</h5>

      <b-table class="datatables" :items="allReports" :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
        responsive="sm">
        <template #cell(download_reports)="row">
          <p v-if="row.item.links === null && row.item.status === 'pending'" class="badge bg-warning">
            Wait for result
          </p>

          <p v-if="row.item.links === null && row.item.status === 'ready'" class="badge bg-danger">
            No data found for selected reports
          </p>

          <div v-for="(link, i) in row.item.links" :key="i" style="display: inline">
            <b-button size="sm" :variant="getVariantByType(link.type_id)" class="m-1"
              @click="downloadSuccess(link.download_url)">
              {{ getFileNameByType(link.type_id) }}
            </b-button>
          </div>
        </template>

        <template #cell(status)="row">
          <p v-if="row.item.status === 'Ready'" class="badge bg-success">
            Ready
          </p>

          <p v-else class="badge bg-warning">Pending</p>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import incidentMixin from "@/mixins/incident";
import Swal from "sweetalert2";
import VueEasyLightbox from "vue-easy-lightbox";

/**
 * Transactions component
 */
export default {
  mixins: [incidentMixin],

  components: {
    DatePicker,
    VueEasyLightbox,
  },
  props: {
    transactions: {
      type: Array,
      default: function () {
        return [];
      },
    },
    updating: {
      type: Boolean,
    },
  },
  data () {
    return {
      showModal: false,
      info: null,
      reportTypes: [],
      checkedTypes: [],
      selectedIncident: {},
      visibleCaption: false,
      index: 1,
      datepickervalueFrom: "",
      datepickervalueTo: "",
      dowloandPdf: false,
      allReports: [],
      allReportLinks: [],
      filterData: [],
      accidentData: [],
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      vehicleDetails: [],
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "from",
          label: "From Date",
          sortable: false,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "to",
          label: "To Date",
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Created At",
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTimeForCreatedAt(value);
          },
        },
        {
          key: "download_reports",
          thStyle: { width: "50%" },
        },
      ],
    };
  },

  computed: {
    rows () {
      return this.filterData.length;
    },

    incidentImages () {
      return this.selectedIncident.images
        ? this.selectedIncident.images.map((e) => e.media_url)
        : [];
    },
  },

  methods: {
    getFileNameByType (typeId) {
      switch (typeId) {
        case 1:
          return "Incident Detail Report";

        case 2:
          return "Incident Summary Report";

        case 3:
          return "Accident Detail Report";

        case 4:
          return "Accident Summary Report";

        case 5:
          return "Traffic Detail Report";

        case 6:
          return "Traffic Summary Report";

        case 7:
          return "VSDS Detail Report";

        case 8:
          return "VIDS Summary Report";

        case 9:
          return "VIDS Detail Report";

        default:
          return "Unknown";
      }
    },
    getVariantByType (typeId) {
      switch (typeId) {
        case 1:
          return "primary";

        case 2:
          return "primary";

        case 3:
          return "warning";

        case 4:
          return "warning";

        case 5:
          return "success";

        case 6:
          return "success";

        default:
          return "secondary";
      }
    },
    closeModal () {
      this.showModal = false;
    },

    downloadSuccess (url) {
      window.open(url);
    },

    async filterDataFromDates () {
      if (this.datepickervalueFrom === "" && this.datepickervalueTo === "") {
        Swal.fire("Please Select From Date And To Date", "", "info");
      } else if (this.datepickervalueFrom && this.datepickervalueTo === "") {
        Swal.fire("Please Select To Date", "", "info");
      } else if (this.datepickervalueFrom === "" && this.datepickervalueTo) {
        Swal.fire("Please Select From Date", "", "info");
      } else if (
        this.datepickervalueFrom &&
        this.datepickervalueTo &&
        this.checkedTypes.length === 0
      ) {
        Swal.fire("Please Select Reports", "", "info");
      } else {
        this.dowloandPdf = true;
        let fromDate = new Date(this.datepickervalueFrom);
        let toDate = new Date(this.datepickervalueTo);

        toDate.setHours(23, 59, 59, 999);

        const body = {
          fromDate: fromDate,
          toDate: toDate,
          reports: this.checkedTypes,
        };

        this.GenerateIncidentReport(body);

        Swal.fire("Requested", "Please visit after some time", "success").then(
          () => {
            this.$router.go();
          }
        );

        this.datepickervalueFrom = "";
        this.datepickervalueTo = "";
        this.checkedTypes = [];
      }
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toJSON().slice(0, 10)}`;
      }
    },

    getReadableDateTimeForCreatedAt (dateTime) {
      if (dateTime) {
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },

    showCaptiomImg (index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide () {
      this.visibleCaption = false;
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    handleCaptionHide () {
      this.visibleCaption = false;
    },

    async showVehicles (id) {
      const body = {
        id: id,
      };
      this.vehicleDetails = await this.ShowVehicleDetails(body);
    },

    async getIncidentMasters () {
      try {
        const incidents = await this.GetIncidentMasters();
        this.reportTypes = incidents.getReportTypes;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async getReportsData () {
      this.allReports = await this.GetReports();
      this.allReportLinks = await this.GetReportLinks();
    },
  },

  async mounted () {
    await this.getIncidentMasters();
    this.getReportsData();
  },
};
</script>

<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>
